const websiteUrl = 'http://lucegas.coopalleanza3-0.it';

const GMAPS_PLACES_AUTOCOMPLETE_URL = 'https://maps.googleapis.com/maps/api/place/autocomplete/json';

const GMAPS_GEOCODE_URL =
  'https://maps.googleapis.com/maps/api/geocode/json';

const GMAPS_API_KEY = 'AIzaSyDznHOPFJKQb1gATdmUNC-TanxlHdG469k';

export {
  websiteUrl,
  GMAPS_PLACES_AUTOCOMPLETE_URL,
  GMAPS_GEOCODE_URL,
  GMAPS_API_KEY,
};



// WEBPACK FOOTER //
// ./src/app/config.ts